/*
 * typeahead.js
 * https://github.com/twitter/typeahead.js
 * Copyright 2013-2014 Twitter, Inc. and other contributors; Licensed MIT
 */

module.exports = '1.0.0';



//////////////////
// WEBPACK FOOTER
// ./node_modules/bloodhound-js/lib/version.js
// module id = XIEK
// module chunks = 1